export function Logo() {
    return (
        <svg
            id="uuid-86c305d7-94df-4880-bc67-7c60a1292330"
            data-name="Livello 2"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 292.09 147.08"
            height={100}
            width={150}
        >
            <defs>
                <style>
                    {
                        "\n      .uuid-6f3eddce-14c4-420d-8f6e-b6de26f0cca6 {\n        fill: #008ccd;\n      }\n\n      .uuid-ccfe0948-a4af-4ff5-b77a-b4c895a62fad {\n        fill: #003148;\n      }\n    "
                    }
                </style>
            </defs>
            <g
                id="uuid-754af393-3c89-4889-8b72-221dda56b2fa"
                data-name="uuid-a464b9c0-1618-492a-97f0-696cd65389df"
            >
                <g
                    id="uuid-00e8c0bf-8047-4d3b-8fe1-6dd259c15a72"
                    data-name="uuid-020f23ec-2404-493f-bbb3-6de09e667e03"
                >
                    <g
                        id="uuid-78d584d0-ae46-48db-b10b-8aae257e07fc"
                        data-name="uuid-cdf2ac8e-0e1e-4004-a629-b71344c1d8ba"
                    >
                        <g>
                            <g>
                                <path
                                    className="uuid-ccfe0948-a4af-4ff5-b77a-b4c895a62fad"
                                    d="M178.39,18.42c6.8,0,11.9,1.8,15.2,5.4s5,8.9,5,15.9v11.2c0,7-1.7,12.3-5,15.9s-8.4,5.4-15.2,5.4h-6.4v32.4h-13.5V18.42h19.9ZM171.99,30.72v29.2h6.4c2.1,0,3.8-.6,4.9-1.7,1.1-1.2,1.7-3.3,1.7-6.4v-12.9c0-3.1-.6-5.3-1.7-6.4-1.1-1.1-2.8-1.7-4.9-1.7h-6.4s0-.1,0,0v-.1Z"
                                />
                                <path
                                    className="uuid-ccfe0948-a4af-4ff5-b77a-b4c895a62fad"
                                    d="M247.59,104.52h-13.7l-2.3-15.6h-16.6l-2.3,15.6h-12.4l13.8-86.2h19.8l13.8,86.2h-.1ZM216.79,77.22h13l-6.5-43.6-6.5,43.6h0Z"
                                />
                                <path
                                    className="uuid-ccfe0948-a4af-4ff5-b77a-b4c895a62fad"
                                    d="M252.19,39.02c0-7,1.7-12.3,5-16,3.3-3.7,8.3-5.6,15-5.6s11.6,1.9,14.9,5.6,5,9.1,5,16v2.7h-12.8v-3.6c0-3.1-.6-5.3-1.8-6.6-1.2-1.3-2.8-1.9-5-1.9s-3.8.6-5,1.9c-1.2,1.3-1.8,3.4-1.8,6.6s.6,5.6,2,7.8c1.3,2.2,3,4.4,4.9,6.4,2,2,4.1,4,6.3,6,2.3,2,4.4,4.2,6.3,6.6,2,2.4,3.6,5.1,4.9,8.1s2,6.6,2,10.7c0,7-1.7,12.3-5.1,16.1-3.4,3.7-8.4,5.6-15.1,5.6s-11.7-1.9-15.1-5.6-5.1-9.1-5.1-16.1v-5.3h12.8v6.2c0,3.1.6,5.3,1.9,6.5s3,1.8,5.1,1.8,3.8-.6,5.1-1.8c1.3-1.2,1.9-3.4,1.9-6.5s-.7-5.6-2-7.8c-1.3-2.3-3-4.4-4.9-6.4-2-2-4.1-4-6.4-6-2.2-2-4.4-4.2-6.3-6.6-2-2.4-3.6-5.1-4.9-8.1-1.3-3-1.8-10.7-1.8-10.7h0Z"
                                />
                                <path
                                    className="uuid-6f3eddce-14c4-420d-8f6e-b6de26f0cca6"
                                    d="M168.99,129.62h-2.9l-.5-3.3h-3.5l-.5,3.3h-2.6l2.9-18.1h4.2l2.9,18.1h0ZM162.49,123.82h2.8l-1.4-9.2-1.4,9.2h0Z"
                                />
                                <path
                                    className="uuid-6f3eddce-14c4-420d-8f6e-b6de26f0cca6"
                                    d="M183.29,116.42v13.1h-2.6v-18.1h3.6l2.9,10.8v-10.8h2.5v18.1h-2.9l-3.6-13.1h.1Z"
                                />
                                <path
                                    className="uuid-6f3eddce-14c4-420d-8f6e-b6de26f0cca6"
                                    d="M211.49,129.62h-2.9l-.5-3.3h-3.5l-.5,3.3h-2.6l2.9-18.1h4.2l2.9,18.1h0ZM204.99,123.82h2.8l-1.4-9.2-1.4,9.2h0Z"
                                />
                                <path
                                    className="uuid-6f3eddce-14c4-420d-8f6e-b6de26f0cca6"
                                    d="M223.29,111.52h2.8v15.5h4.7v2.6h-7.5v-18.1Z"
                                />
                                <path
                                    className="uuid-6f3eddce-14c4-420d-8f6e-b6de26f0cca6"
                                    d="M243.59,123.62l-3.6-12.1h3l2.2,8.2,2.2-8.2h2.7l-3.6,12.1v6h-2.8v-6h-.1,0Z"
                                />
                                <path
                                    className="uuid-6f3eddce-14c4-420d-8f6e-b6de26f0cca6"
                                    d="M261.09,115.82c0-1.5.3-2.6,1-3.3.7-.8,1.8-1.2,3.1-1.2s2.5.4,3.1,1.2c.7.8,1.1,1.9,1.1,3.3v.6h-2.7v-.8c0-.7-.1-1.1-.4-1.4-.2-.3-.6-.4-1.1-.4s-.8,0-1,.4-.4.7-.4,1.4.1,1.2.4,1.7.6.9,1,1.3.9.8,1.3,1.3c.5.4.9.9,1.3,1.4s.8,1.1,1,1.7.4,1.4.4,2.2c0,1.5-.4,2.6-1.1,3.4-.7.8-1.8,1.2-3.2,1.2s-2.5-.4-3.2-1.2-1.1-1.9-1.1-3.4v-1.1h2.7v1.3c0,.7.1,1.1.4,1.4.3.2.6.4,1.1.4s.8,0,1.1-.4c.3-.3.4-.7.4-1.4s-.1-1.2-.4-1.7-.6-.9-1-1.3-.9-.8-1.3-1.3c-.5-.4-.9-.9-1.3-1.4s-.8-1.1-1-1.7c-.3-.6-.2-2.2-.2-2.2h0Z"
                                />
                                <path
                                    className="uuid-6f3eddce-14c4-420d-8f6e-b6de26f0cca6"
                                    d="M280.79,111.52h8.8v2.6h-3v15.5h-2.8v-15.5h-3v-2.6Z"
                                />
                            </g>
                            <path
                                className="uuid-6f3eddce-14c4-420d-8f6e-b6de26f0cca6"
                                d="M125.89,21.72C87.59-18.18,17.39-.38,2.59,52.92c-2.8,10-4.9,19.2,2.4,27.7,15.3,17.8,48.4,25.7,71,23.3,2.2-.2,4.4-.9,6.5-1.2.3,0,1.1-.3,1,.2-9.4,3.2-18.9,6.4-28.7,7.9-14.1,2.2-32.7-1.2-45.3-8-1.4-.8-2.6-2.3-4.4-2.2,0,.9.2,1.7.5,2.6,8.5,23.5,33.5,40.1,57.7,43.2,70.3,8.9,111.5-74,62.7-124.8h0v.1h-.1ZM122.19,86.92l-4.9,22.2c-.5,1.3-2,1.8-3,2.6v-20.5l-16.8,6.7c-.9.8-.4,3.9-.4,5.3s0,4-1.8,4l-1.6-7.1c-1.2-.9-2.5.2-3.7.3l2.4-1.9c.3-.4,0-.8,0-1.2-.4-.8-5.1-5.2-4.9-5.5l1.6-.5c1.7.9,6.1,4.5,7.8,4.3l14.5-8.9v-1.2l-15.7-11.2c-.3-.6,2.5-1.6,3.1-1.5l20.4,9.1c3.4.4,9.8-4.8,13.1-4.5.6,0,1.8.7,1.7,1.4-.4,2.7-9.3,6.4-11.5,8.1h-.3Z"
                            />
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    )
}